// --- Icons ---
import {
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
export type Level = 1 | 2 | 3 | 4 | 5 | 6;

export const headingIcons = {
  1: fa1,
  2: fa2,
  3: fa3,
  4: fa4,
  5: fa5,
  6: fa6,
};

export function getFormattedHeadingName(level: Level): string {
  return `Heading ${level}`;
}
